import styled, { css } from 'styled-components';
import { createTheme } from "@mui/material/styles";

interface SelectMenuProps {
  isOpen: boolean;
}

export const Container = styled.div`
  width: 100%;
`;

export const SelectMenu = styled.div<SelectMenuProps>`
  width: 100%;
  margin: 2.2rem 0 1rem 0;
  transition: all .2s ease-in-out;

  svg {
    ${({ isOpen }) => !isOpen && css`
      transform: rotate(-180deg);
      transition: all .2s ease-in-out;
    `}
  }

  .option_items {
    ${({ isOpen }) => !isOpen && css`
      display: none;
      transition: all .2s ease-in-out;
    `}
  }

  button {
    ${({ isOpen }) => !isOpen
      ? css`
        max-width: auto;
        background: ${({ theme }) => theme.colors.select_close_filter_buttons};
        transition: all .2s ease-in-out;

        p {
          color: ${({ theme }) => theme.colors.select_close_buttons_text};
        }
      `
      : css`
        width: 100%;
        background: ${({ theme }) => theme.colors.select_open_filter_buttons};
        transition: all .2s ease-in-out;

        p {
          color: ${({ theme }) => theme.colors.select_open_buttons_text};
        }
      `
    };
  }
`;

export const SelectButton = styled.button`
  height: 33px;

  border: none;
  display: flex;

  padding:  23px;
  cursor: pointer;

  font-size: 18px;
  align-items: center;
  
  font-weight: 400;
  border-radius: 100px;

  
  justify-content: space-between;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.20), 
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 
    0px 1px 18px 0px rgba(0, 0, 0, 0.12);

  p {
    color: #505A5F;
    font-size: 19px;
    font-weight: 400;
    line-height: 130%;
    font-style: normal;
  }
`;

export const Options = styled.div`
  width: 100%;
  padding: 20px;

  margin-top: 10px;

  background: #fff;

  @media (max-width: 414px) {
    padding: 0;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;

  margin-bottom: 1rem;
  margin-top: 2.25rem;
  
  background: 
    linear-gradient(90deg, rgba(177, 180, 182, 0.00) 
      0.52%, #B1B4B6 53.13%, rgba(177, 180, 182, 0.00) 100%);
`;

export const materialTheme = createTheme({
  palette: {
    primary: {
      main: "#2196F3",
    },
    secondary: {
      main: "#0B0C0C",
    },
  },
});

export const SubItemsContainer = styled.div`
  width: 100%;
`;

export const SubItemsWrapper = styled.div<SelectMenuProps>`
  width: 100%;
  transition: all .5s ease-in-out;

  .option_subitems {
    width: 100%;
    display: flex;
    padding: 20px;
    margin-top: -35px;
    flex-direction: column;
  }

  .option_subitems {
    ${({ isOpen }) => !isOpen && css`
      display: none;
      transition: all .5s ease-in-out;

    `}
  }
`;

export const SelectSubItem = styled.div`
  width: 100%;
  display: flex;
`;

interface CheckDividerProps {
  clicked: boolean;
}

export const CheckDivider = styled.div<CheckDividerProps>`
  width: 100%;
  height: 1px;
  background: ${({ clicked }) => !clicked ? 'grey' : '#00C0F3'};
`;
